import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SVG from "../../SVG";
import { Tooltip } from "react-tooltip";
export default function Quit() {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isConfirmOpen) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsConfirmOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isConfirmOpen]);

  const handleConfirmQuit = () => {
    localStorage.removeItem("email");
    localStorage.removeItem("refresh");
    localStorage.removeItem("access");
    localStorage.removeItem("role");
    setIsConfirmOpen(false);
    navigate("/signin", { replace: true });
  };

  return (
    <>
      <button
        type="button"
        className="outline-none"
        data-tooltip-id="quitTooltip"
        data-tooltip-content="خروج"
        onClick={() => setIsConfirmOpen(true)}
      >
        <SVG name="quit" classname="size-5 drop-shadow-md cursor-pointer" />
      </button>

      <Tooltip
        id="quitTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-cyan-600 !rounded-lg"
      />

      {isConfirmOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4 backdrop-blur"
          onClick={() => setIsConfirmOpen(false)}
        >
          <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="quit-confirm-title"
            className="w-full max-w-fit rounded-2xl bg-zi-bg2-light p-5 text-right shadow-2xl drop-shadow-lg dark:bg-zi-bg2-dark/100"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="flex flex-col gap-3">
              <h5
                id="quit-confirm-title"
                className="text-base font-medium text-zi-text-light dark:text-zi-text-dark sm:text-lg"
              >
                آیا از خروج مطمئن هستید؟
              </h5>
              <p className="text-sm leading-6 text-zi-text-light/70 dark:text-zi-text-dark/70">
                با خروج از حساب، برای ورود دوباره باید اطلاعات خود را وارد کنید.
              </p>
            </div>

            <div className="mt-6 grid grid-cols-2 gap-3">
              <button
                type="button"
                className="rounded-xl border border-zi-border-light bg-zi-bg1-light px-4 py-2.5 text-sm text-zi-text-light outline-none hocus:ring-1 ring-inset hocus:ring-zi-border-dark dark:border-zi-border-dark dark:bg-transparent dark:text-zi-text-dark"
                onClick={() => setIsConfirmOpen(false)}
              >
                انصراف
              </button>
              <button
                type="button"
                className="rounded-xl bg-cyan-600 px-4 py-2.5 text-sm text-zi-text-dark outline-none hocus:opacity-85"
                onClick={handleConfirmQuit}
              >
                خروج
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
